import { useOverrides } from '@components/hooks/use-overrides'
import {
  PopoverOverrides,
  StatefulPopover,
  StatefulPopoverProps,
} from 'baseui/popover'
import { borderRadius } from 'polished'

interface BasePopoverProps extends StatefulPopoverProps {}

export const BasePopover = ({
  children,
  overrides,
  ...props
}: BasePopoverProps) => {
  return (
    <StatefulPopover
      focusLock
      returnFocus
      renderAll
      autoFocus={false}
      overrides={useOverrides<PopoverOverrides>(
        {
          Body: {
            style: {
              marginTop: '4px',
              ...borderRadius('top', '16px'),
              ...borderRadius('bottom', '16px'),
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
              zIndex: 999,
            },
          },
          Inner: {
            style: {
              backgroundColor: 'white',
              ...borderRadius('top', '16px'),
              ...borderRadius('bottom', '16px'),
            },
          },
        },
        overrides
      )}
      {...props}
    >
      {children}
    </StatefulPopover>
  )
}
